var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcFavouriteCarousel(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "70px",
    height: "70px",
    viewBox: "0 0 70 70",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icFavouriteCarousel") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-228.000000, -160.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icFavouriteCarousel",
    transform: "translate(228.000000, 160.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    cx: 35,
    cy: 35,
    r: 35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1102329,32.8408087 C54.9172518,32.0599284 55.2021303,30.9138765 54.8540368,29.8485209 C54.5051221,28.7831655 53.5963022,28.022663 52.4797754,27.8612702 L42.5525388,26.4291129 C42.1297364,26.3679792 41.7644023,26.104697 41.5755779,25.7240382 L37.137384,16.7936365 C36.6390519,15.7902298 35.62761,15.1666667 34.5004105,15.1666667 C33.3740321,15.1666667 32.3625902,15.7902298 31.864258,16.7936365 L27.4252431,25.7248534 C27.2364187,26.1055122 26.8702636,26.3687943 26.4474611,26.429928 L16.5202246,27.8620853 C15.4045189,28.022663 14.494878,28.7839805 14.1459633,29.8493361 C13.7978696,30.9146916 14.0827482,32.0607435 14.8897672,32.8416239 L22.0724824,39.7929259 C22.3787062,40.0896278 22.5190931,40.5167482 22.4468473,40.9340871 L20.7523537,50.7497039 C20.6021151,51.613726 20.8303464,52.4541098 21.3935356,53.1167984 C22.2686955,54.1495493 23.796531,54.4641837 25.0181427,53.8267637 L33.8961725,49.1920189 C34.2672534,48.9988366 34.7343885,49.0004668 35.1046485,49.1920189 L43.9834992,53.8267637 C44.4153324,54.0525505 44.8758997,54.1666666 45.3512445,54.1666666 C46.2190157,54.1666666 47.0416332,53.7835626 47.6072854,53.1167984 C48.1712957,52.4541098 48.3987058,51.6120957 48.2484673,50.7497039 L46.5531528,40.9340871 C46.480907,40.515933 46.6212937,40.0896278 46.9275176,39.7929259 L54.1102329,32.8408087 Z",
    id: "path-1",
    stroke: "#10C2E1",
    strokeWidth: 2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFavouriteCarousel);
export default __webpack_public_path__ + "static/media/icFavouriteCarousel.d47fff02e1db0da9c9b112d79e63b497.svg";
export { ForwardRef as ReactComponent };